export class CarrierContactInfo {
    carrierContactInfoId: any;
    carrierId: any;
    contactType: any;
    firstName: any;
    lastName: any;
    middleIntial: any;
    email: any;
    phone: any;
    phoneExt: any;
    updateProgram: any;
    updateId: any;
    updateDate: any;
}
